import { Outlet, createFileRoute } from "@tanstack/react-router";

import { m } from "@/paraglide/messages.js";

/** Gives a specialist's page its breadcrumb step: Specialists > Marta Lis. */
export const Route = createFileRoute("/(private)/book")({
  loader: () => ({ crumb: m.find_specialists() }),
  component: Outlet,
});
